import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
/** Absolute URL for backend-relative media paths like "/api/media/<id>". */
export const mediaUrl = (path) => (path && path.startsWith("/") ? `${BACKEND_URL}${path}` : path || "");

// Public axios (no credentials required)
export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Admin axios — auth via Bearer token in localStorage (works cross-origin)
export const adminApi = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("fi_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      // Clear stale token but do NOT redirect — the AdminLayout route guard
      // handles redirects for admin pages, and public pages must stay put
      // even when the /admin/me probe returns 401.
      localStorage.removeItem("fi_admin_token");
    }
    return Promise.reject(error);
  }
);

/** Format FastAPI 422 error detail array/object to a readable string */
export function formatApiError(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
